// @ts-ignore
import createObjectVersionManager from 'powtoon-commons/json-versioning'
// @ts-ignore
import {versions, validateByLastVersion} from './versions'
// @ts-ignore
import {getLastVersionName, getVersionNames} from 'powtoon-commons/json-versioning/utils'
import {UserStudioSettings} from 'powtoon-services/current-user/types'

export const updateUserStudioSettings = createObjectVersionManager({
  getUpgradeFunction: (version: any) => version.upgrade,
  versions
})

export const getInitialUserSettingsState = (): UserStudioSettings => ({
  ...validateByLastVersion.DEFAULT_SETTINGS,
  version: getLastVersionName(getVersionNames(versions))
}) as any
